import { useFilterQuoteAccommodationContext } from "./filter-quote-accommodation.context";

export function FilterQuoteAccommodation() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterQuoteAccommodationContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}